export default __webpack_public_path__ + "static/media/client-profile.06d231a2.svg";